import { render } from "./WorkingGroups.vue?vue&type=template&id=38c04434&scoped=true"
import script from "./WorkingGroups.vue?vue&type=script&lang=js"
export * from "./WorkingGroups.vue?vue&type=script&lang=js"

import "./WorkingGroups.vue?vue&type=style&index=0&id=38c04434&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38c04434"]])

export default __exports__